// @ts-expect-error - Automatic, Please fix when editing this file
const selectCart = (state) => state?.cart;

export default selectCart;
